export const PROPERTY_PHOTO_PANEL_ERROR = 'There was an error fetching Image Gallery data.'

export const VALUATION_ESTIMATES_PANEL_ERROR = 'There was an error fetching Valuation Estimates data.'

export const RATING_VALUATION_PANEL_ERROR = 'There was an error fetching Rating Valuation data.'

export const TITLE_DETAILS_PANEL_ERROR = 'There was an error fetching Record of Title Detail data.'

export const COPYRIGHT_PANEL_ERROR = 'Unable to fetch copyright (statusCode)'

export const DISCLAIMER_PANEL_ERROR = 'Unable to fetch disclaimer (statusCode)'

export const PROPERTY_TIMELINE_PANEL_ERROR =
  'There was an error fetching Property History data.'

export const COMPARABLE_PROPERTIES_PANEL_ERROR =
  'There was an error fetching Comparable Properties data.'

export const LOCAL_SCHOOLS_PANEL_ERROR =
  'There was an error fetching Local Schools data.'

export const MARKET_INSIGHTS_PANEL_ERROR = 'There was an error fetching market insights data.'

export const MARKET_INSIGHTS_NOT_AVAILABLE = 'Sorry, Market Insights is not available for this property.'

export const MAP_PANEL_ERROR = 'There was an error fetching Map data.'
